import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useFaqs, DEFAULT_FAQS } from "@/hooks/useFaqs";

export const faqs = DEFAULT_FAQS;

const FAQSection = () => {
  const faqs = useFaqs();
  return (

    <section className="py-20 md:py-28 bg-navy">
      <div className="container mx-auto px-4 max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-primary font-sans font-semibold tracking-[0.2em] uppercase text-sm mb-3">
            FAQ
          </p>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-hero-foreground">
            Frequently Asked <span className="text-primary">Questions</span>
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-hero-foreground/10 rounded-xl px-6 bg-hero-foreground/5"
            >
              <AccordionTrigger className="text-hero-foreground font-sans font-semibold text-left hover:no-underline hover:text-primary">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-hero-foreground/70 font-sans leading-relaxed">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
